'use client'

import { createContext, useContext } from 'react'

import type { PricesSectionProps, PriceModelData, PriceLevelTab, PriceSellerData } from './price-section-types'

export interface PurchaseContextValue {
  data: PricesSectionProps
  selectedModel: PriceModelData
  selectedLevel: PriceLevelTab
  sellers: PriceSellerData[]
  configuration: string
  selectModel: (id: number) => void
  selectLevel: (id: number) => void
}

export const PurchaseContext = createContext<PurchaseContextValue | null>(null)
export const useProductPurchase = () => useContext(PurchaseContext)
